<div>
	<mat-form-field>
		<input
			matInput
			(keyup)="applyFilter($event.target.value)"
			placeholder="Filter"
		/>
	</mat-form-field>
</div>

<table
	mat-table
	[dataSource]="dataSource"
	[trackBy]="trackById"
	matSort
	class="animate app-table"
>
	<ng-container matColumnDef="lastUpdatedAt">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Updated</th>
		<td mat-cell *matCellDef="let element">
			{{ element.date | date: 'short' }}
		</td>
	</ng-container>

	<ng-container matColumnDef="userName">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>User</th>
		<td mat-cell *matCellDef="let element">{{ element.userName }}</td>
	</ng-container>

	<ng-container matColumnDef="property">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Property</th>
		<td mat-cell *matCellDef="let element">{{ element.property }}</td>
	</ng-container>

	<ng-container matColumnDef="from">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>From</th>
		<td mat-cell *matCellDef="let element">
			{{ getValue(element.property, element.from) }}
		</td>
	</ng-container>

	<ng-container matColumnDef="to">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>To</th>
		<td mat-cell *matCellDef="let element">
			{{ getValue(element.property, element.to) }}
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
	<tr
		mat-row
		*matRowDef="let row; columns: displayedColumns"
		class="animate"
	></tr>
</table>
